import styled from 'styled-components';
import { Card, Space, Row } from 'antd';
import { CopyOutlined, DeleteOutlined, FilePdfOutlined, SendOutlined } from '@ant-design/icons';

export const BravoCopyIcon = styled(CopyOutlined)`
  color: var(--primary-color);
`;

export const BravoDeleteIcon = styled(DeleteOutlined)`
  color: var(--primary-color);
`;

export const BravoPdfIcon = styled(FilePdfOutlined)`
  color: var(--primary-color);
`;

export const BravoSendIcon = styled(SendOutlined)`
  color: var(--primary-color);
`;

export const RootCard = styled(Card)`
  .ant-card-body {
    padding: 0;
  }
`;

export const BasicInfoRow = styled(Row)`
  padding: var(--size-lg) var(--size-lg) 0;
`;

export const QuickActionsSpace = styled(Space)`
  padding: 0 var(--size-lg) var(--size-lg);
`;
